import axios from 'axios';
import config from '../config.json';
var id = config.event;

export default {

    getAllActions() {
        return axios.get(config.server + '/events/')
    },
    getMainAction() {
        return axios.get(config.server + '/events/' + id);
    },
    getIssuesAction() {
        return axios.get(config.server + `/issues?event=${id}`);
    },
    getPostsAction() {
        return axios.get(config.server + `/posts?event=${id}&limit=100`);
    },
    getTeamsAction() {
        return axios.get(config.server + `/events/${id}/participants?limit=10000`);
    },

    getTeamGPS(idteam) {
        return axios.get(config.server + `/gps?team=${idteam}&event=${id}&date=1`);
    },

    getTeamAction(idteam, data) {
        if (data == undefined) {
            return axios.get(config.server + `/events/participants?team=${idteam}&event=${id}`);
        }

        if (data == 'posts') {
            return axios.get(config.server + `/posts?owner=${idteam}`);
        }

        if (data == 'media') {
            return axios.get(config.server + `/posts?owner=${idteam}&media=true`);
        }

        if (data == 'issues') {
            return axios.get(config.server + `/issues?team=${idteam}`);
        }
    },
    getGpsAction(time) {
        return axios.get(config.server + `/gps?event=${id}&limit=0&date=${time}`)
    },
    getMediaAction() {
        return axios.get(config.server + `/events/${id}/media?limit=100`)
    },
    getStatusAction() {
        return axios.get(config.server + `/events/${id}/stats`)
    },
    getComments(id){
      return axios.get(config.server + `/comments?post=${id}`)
    }
}
